import { useEffect, useState } from 'react'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './carousel'
import Container from './container'

export default function CloudBadges() {
  // Databricks carousel state
  const [dbApi, setDbApi] = useState(null)
  const [dbCurrent, setDbCurrent] = useState(0)
  const [dbCount, setDbCount] = useState(0)

  // Azure carousel state
  const [azApi, setAzApi] = useState(null)
  const [azCurrent, setAzCurrent] = useState(0)
  const [azCount, setAzCount] = useState(0)

  // Databricks badges data
  const databricksBadges = [
    { id: 1, src: '../assets/cloud/db1.svg' },
    { id: 2, src: '../assets/cloud/db2.svg' },
    { id: 3, src: '../assets/cloud/db3.svg' },
    { id: 4, src: '../assets/cloud/db4.svg' },
    { id: 5, src: '../assets/cloud/db5.svg' },
    { id: 6, src: '../assets/cloud/db6.svg' },
    { id: 7, src: '../assets/cloud/db7.svg' },
  ]

  // Azure badges data
  const azureBadges = [
    { id: 1, src: '../assets/cloud/az1.svg' },
    { id: 2, src: '../assets/cloud/az2.svg' },
    { id: 3, src: '../assets/cloud/az3.svg' },
    { id: 4, src: '../assets/cloud/az4.svg' },
    { id: 5, src: '../assets/cloud/az5.svg' },
  ]

  // Effect for Databricks carousel
  useEffect(() => {
    if (!dbApi) return

    const onSelect = () => {
      setDbCurrent(dbApi.selectedScrollSnap())
    }

    dbApi.on('select', onSelect)
    setDbCount(dbApi.scrollSnapList().length)
    setDbCurrent(dbApi.selectedScrollSnap())

    return () => {
      dbApi.off('select', onSelect)
    }
  }, [dbApi])

  // Effect for Azure carousel
  useEffect(() => {
    if (!azApi) return

    const onSelect = () => {
      setAzCurrent(azApi.selectedScrollSnap())
    }

    azApi.on('select', onSelect)
    setAzCount(azApi.scrollSnapList().length)
    setAzCurrent(azApi.selectedScrollSnap())

    return () => {
      azApi.off('select', onSelect)
    }
  }, [azApi])

  // Function to navigate to a specific slide for Databricks
  const goToDbSlide = index => {
    if (dbApi) {
      dbApi.scrollTo(index)
    }
  }

  // Function to navigate to a specific slide for Azure
  const goToAzSlide = index => {
    if (azApi) {
      azApi.scrollTo(index)
    }
  }

  return (
    <section className="bg-[#0B0B1F] py-20">
      <Container>
        <h2 className="font-inter-light text-white text-center text-2xl md:text-[36px] mb-16">
          Nossa excelência é certificada por diversas plataformas
        </h2>

        {/* Databricks Carousel */}
        <div className="mb-16">
          <div className="flex items-center">
            <div className="w-1/5 flex justify-center">
              <img
                src="../assets/cloud/databricks_logo.svg"
                alt="Databricks Logo"
                className="w-28 h-auto"
              />
            </div>
            <div className="w-4/5 relative">
              <Carousel setApi={setDbApi} className="w-full">
                <CarouselContent className="pr-8">
                  {databricksBadges.map(badge => (
                    <CarouselItem
                      key={badge.id}
                      className="basis-1/3 md:basis-1/4 lg:basis-1/4"
                    >
                      <div className="p-2 flex justify-center">
                        <img
                          src={badge.src}
                          alt={`Databricks Badge ${badge.id}`}
                          className="h-28 w-auto object-contain"
                        />
                      </div>
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <CarouselPrevious className="hidden md:block left-0 text-white hover:cursor-pointer" />
                <CarouselNext className="hidden md:block right-0 text-white hover:cursor-pointer" />
              </Carousel>
            </div>
          </div>

          {/* Databricks Indicators */}
          <div className="flex justify-center gap-2 mt-6 md:w-4/5 md:ml-auto">
            {Array.from({ length: dbCount }).map((_, index) => (
              <button
                type="button"
                key={index}
                onClick={() => goToDbSlide(index)}
                className={`${
                  dbCurrent === index ? 'w-[24px]' : 'w-[8px]'
                } h-[8px] rounded-full cursor-pointer transition-all duration-300 ${
                  dbCurrent === index
                    ? 'bg-transparent border border-white'
                    : 'bg-white'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Azure Carousel */}
        <div>
          <div className="flex items-center">
            <div className="w-1/5 flex justify-center">
              <img
                src="../assets/cloud/azure_logo.svg"
                alt="Azure Logo"
                className="w-28 h-auto object-contain"
              />
            </div>
            <div className="w-4/5 relative">
              <Carousel setApi={setAzApi} className="w-full">
                <CarouselContent className="pr-8">
                  {azureBadges.map(badge => (
                    <CarouselItem
                      key={badge.id}
                      className="basis-1/3 md:basis-1/4 lg:basis-1/4"
                    >
                      <div className="p-2 flex justify-center">
                        <img
                          src={badge.src}
                          alt={`Azure Badge ${badge.id}`}
                          className="h-28 w-auto object-contain"
                        />
                      </div>
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <CarouselPrevious className="left-0 text-white hover:cursor-pointer" />
                <CarouselNext className="right-0 text-white hover:cursor-pointer" />
              </Carousel>
            </div>
          </div>

          {/* Azure Indicators */}
          <div className="flex justify-center gap-2 mt-6 md:w-4/5 md:ml-auto">
            {Array.from({ length: azCount }).map((_, index) => (
              <button
                type="button"
                key={index}
                onClick={() => goToAzSlide(index)}
                className={`${
                  azCurrent === index ? 'w-[24px]' : 'w-[8px]'
                } h-[8px] rounded-full cursor-pointer transition-all duration-300 ${
                  azCurrent === index
                    ? 'bg-transparent border border-white'
                    : 'bg-white'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </Container>
    </section>
  )
}
